var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.863 18.813l-5.039-5.04a.464.464 0 00-.332-.136h-.402A8.124 8.124 0 008.125 0 8.124 8.124 0 000 8.125a8.124 8.124 0 0013.637 5.969v.398c0 .125.05.242.136.332l5.04 5.04a.47.47 0 00.664 0l.386-.387a.47.47 0 000-.665zM8.125 15A6.87 6.87 0 011.25 8.125 6.87 6.87 0 018.125 1.25 6.87 6.87 0 0115 8.125 6.87 6.87 0 018.125 15z"
  })));
}

export default SvgSearch;